import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import ShareDialog from '../modals/ShareDialog';

const APP_URL = process.env.REACT_APP_FRONTEND_URL;

const DropDownReviewShareItem = (props) => {
    
    const [url, setUrl] = useState("");
    const [shareDialogIsOpen, setShareDialogIsOpen] = useState(false);

    useEffect(() => {
        if(props.review && props.listing) {
            setUrl(APP_URL + '/review/' + props.review.id + '/' + props.listing.slug)
        }
    }, [props.review, props.listing]);

    const handleShareToggle = () => {
        setShareDialogIsOpen(true);
	}
    
    const handleShareDialogClose = () => {
	    setShareDialogIsOpen(false);
	}

    return (
        <>
            <Link 
                to="#"
                onClick={handleShareToggle} 
            > 
                <i className="fas fa-share"></i> Share Review
            </Link>  

            {url && (
                <ShareDialog 
                    dialogIsOpen={shareDialogIsOpen} 
                    handleDialogClose={handleShareDialogClose} 
                    setDialogIsOpen={setShareDialogIsOpen}
                    listing={props.listing}
                    url={url}
                    isListing={false}
                />
            )}
        </>
    );
};

export default DropDownReviewShareItem;